<template>
    <div id="face">
        <div class="face-capture" id="face-capture" v-show="showContainer">
            <p class="tip">请保持面部在取景框内</p>
            <video :height="vheight" :width="vwidth" id="video" playsinline webkit-playsinline></video>
             
            <canvas :height="cheight" :width="cwidth" id="refCanvas"></canvas>
            <!--            <img alt="" class="img-cover" src="../assets/cryscore.png"/>-->
            <p class="contentp">{{ scanTip }}</p>
        </div>
       
        <div class="img-face" v-if="!showContainer">
            <img :src="imgUrl" class="imgurl" />
            <el-button type="warning" @click="startQuestion">开始答题</el-button>
        </div>
        <!--        <div class="img-face">-->
        <!--            <el-button type="warning" @click="startQuestion">开始Skip答题</el-button>-->
        <!--        </div>-->

    </div>
</template>

<script>
import api from '@/api/index'
require('tracking/build/tracking-min.js');
require('tracking/build/data/face-min.js');
require('tracking/build/data/eye-min.js');
require('tracking/build/data/mouth-min.js');
export default {
    name: "FacePhoto",
    data() {
        return {
            screenSize: {
                width: window.screen.width,
                height: window.screen.height,
            },
            URL: null,
            streamIns: null, // 视频流
            showContainer: true, // 显示
            tracker: null,
            tipFlag: false, // 提示用户已经检测到
            flag: false, // 判断是否已经拍照
            context: 0, // canvas上下文
            profile: [], // 轮廓
            removePhotoID: null, // 停止转换图片
            scanTip: "人脸检测中...", // 提示文字
            imgUrl: "",
            canvas: null,
            trackertask: null,
            vwidth: 0,
            vheight: 0,
            cwidth: 0,
            cheight: 0,
            userInfo: {},
            orderData: {},
            Nums: 6,
            upCounter: 0,
            sj_id: 0,
        };
    },
    mounted() {

        //设置video canvas宽高
        const scale = this.screenSize.width / 375;
        this.vwidth = 266 * scale;
        this.vheight = 266 * scale;
        this.cwidth = 266 * scale;
        this.cheight = 266 * scale;
        var sj_id = this.$route.params.sj_id;
        this.sj_id = sj_id;
        this.$alert('问卷作答时会实时抓取面部表情信息，请允许访问用户媒体', '提示', {
            confirmButtonText: '确定',
            callback: action => {
                this.playVideo();
            }
        });
    },
    beforeDestroy() {
        // 在组件销毁前关闭摄像头和停止人脸追踪
        this.close();
    },
    methods: {
        playVideo() {
            this.getUserMedia(
                { //摄像头拍摄的区域
                    video: {
                        width: this.vwidth,
                        height: this.vheight,
                        facingMode: "user",
                    } /* 前置优先 */,
                },
                this.success,
                this.error
            );
        },
        // 访问用户媒体设备
        getUserMedia(constrains, success, error) {
            if (navigator.mediaDevices.getUserMedia) {
                //最新标准API
                navigator.mediaDevices
                    .getUserMedia(constrains)
                    .then(success)
                    .catch(error);
            } else if (navigator.webkitGetUserMedia) {
                //webkit内核浏览器
                navigator.webkitGetUserMedia(constrains).then(success).catch(error);
            } else if (navigator.mozGetUserMedia) {
                //Firefox浏览器
                navagator.mozGetUserMedia(constrains).then(success).catch(error);
            } else if (navigator.getUserMedia) {
                //旧版API
                navigator.getUserMedia(constrains).then(success).catch(error);
            } else {
                this.scanTip = "您的浏览器不支持访问用户媒体设备";
            }
        },
        success(stream) {
            this.streamIns = stream;
            const video = document.getElementById("video");
            // webkit内核浏览器
            this.URL = window.URL || window.webkitURL;
            if ("srcObject" in video) {
                video.srcObject = stream;
            } else {
                video.src = this.URL.createObjectURL(stream);
            }
            // 苹果手机的系统弹框会阻止js的线程的继续执行 手动0.1秒之后自动执行代码
            setTimeout(() => {
                video.play();
                this.initTracker();// 人脸捕捉
            }, 100);
        },
        error(e) {
            this.scanTip = "访问用户媒体被拒绝，请重试或更换浏览器";
        },
        initTracker() {
            this.context = document.getElementById("refCanvas").getContext("2d"); // 画布
            this.canvas = document.getElementById("refCanvas");
            this.tracker = new window.tracking.ObjectTracker("face"); // tracker实例
            this.tracker.setInitialScale(4);
            this.tracker.setStepSize(2); // 设置步长
            this.tracker.setEdgesDensity(0.1);
            try {
                this.trackertask = window.tracking.track("#video", this.tracker); // 开始追踪
            } catch (e) {
                this.scanTip = "访问用户媒体失败，请重试";
            }
            //开始捕捉方法 一直不停的检测人脸直到检测到人脸
            this.tracker.on("track", (e) => {
                //画布描绘之前清空画布
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
                if (e.data.length === 0) {
                    this.scanTip = "未检测到人脸";
                } else {
                    e.data.forEach((rect) => {
                        //设置canvas 方框的颜色大小
                        this.context.strokeStyle = "#42e365";
                        this.context.lineWidth = 2;
                        this.context.strokeRect(rect.x, rect.y, rect.width, rect.height);
                    });
                    if (!this.tipFlag) {
                        this.scanTip = "检测成功，请保持不动2秒";
                    }
                    // 1.5秒后拍照，仅拍一次 给用户一个准备时间
                    // falg 限制一直捕捉人脸，只要拍照之后就停止检测
                    if (!this.flag) {
                        // this.scanTip = "拍照中...";
                        this.flag = true;
                        this.removePhotoID = setTimeout(() => {
                            for (this.Nums; this.Nums > 0; this.Nums--) {
                                this.takePhoto(this.Nums);
                                this.sleep(400);
                            }
                            this.close();
                            document.getElementById("video").pause();
                            this.tipFlag = true;
                        }, 1500);
                    }
                }
            });
        },
        sleep(ms) {
            var unixtime_ms = new Date().getTime();
            while (new Date().getTime() < unixtime_ms + ms) { }
        },
        takePhoto(i) {
            // 在画布上面绘制拍到的照片
            this.context.drawImage(
                document.getElementById("video"), 0, 0,
                this.vwidth, this.vwidth
            );
            // 保存为base64格式
            this.imgUrl = this.saveAsPNG(document.getElementById("refCanvas"));
            // this.compare(imgUrl)
            // //判断图片大小
            this.imgSize();
            // this.uploadFace(i);
            this.close();
        },
        uploadFace(i) {  // 图像上传
            var that = this;
            let data = new FormData();
            data.append('uid', this.$store.state.uid);
            data.append('num', i);
            let blob = this.getBlobBydataURI(this.imgUrl, 'image/png');
            data.append("file", blob);
            this.$http.post(api.UploadFace, data).then(function (res) {
                if (res.data.msg === 'success') {
                    // console.log('ok!');
                } else {
                    console.log(res);
                }
            })
        },
        imgSize() {
            if (this.imgUrl) {
                // 获取base64图片byte大小
                const equalIndex = this.imgUrl.indexOf("="); // 获取=号下标
                let size;
                if (equalIndex > 0) {
                    const str = this.imgUrl.substring(0, equalIndex); // 去除=号
                    const strLength = str.length;
                    const fileLength = strLength - (strLength / 8) * 2; // 真实的图片byte大小
                    size = Math.floor(fileLength / 1024); // 向下取整
                    // console.log("size", size + "KB");
                } else {
                    const strLength = this.imgUrl.length;
                    const fileLength = strLength - (strLength / 8) * 2;
                    size = Math.floor(fileLength / 1024); // 向下取整
                    // console.log("size", size + "KB");
                }
                if (size > 1024) {
                    // 图片超过1M 按比例压缩
                    this.imgUrl = document
                        .getElementById("refCanvas")
                        .toDataURL("image/png", 1024 / size);
                }
            }
        },
        // Base64转文件
        getBlobBydataURI(dataURI, type) {
            var binary = window.atob(dataURI.split(",")[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {
                type: type,
            });
        },
        // compare(url) {
        //     let blob = this.getBlobBydataURI(url, 'image/png')
        //     let formData = new FormData()
        //     formData.append("file", blob, "file_" + Date.parse(new Date()) + ".png")
        //     // 得到文件后进行人脸识别
        // },
        // 保存为png,base64格式图片
        saveAsPNG(c) {
            return c.toDataURL("image/png", 0.4);
        },
        close() {
            this.flag = false;
            this.tipFlag = false;
            this.showContainer = false;
            this.context = null;
            this.scanTip = "人脸检测中...";
            clearTimeout(this.removePhotoID);
            if (this.streamIns) {
                this.streamIns.enabled = false;
                this.streamIns.getTracks()[0].stop();
                this.streamIns.getVideoTracks()[0].stop();
            }
            this.streamIns = null;
            this.trackertask.stop();
            this.tracker = null;
        },
        startQuestion() {
            this.$router.push('/question/' + this.sj_id)
        }
    }
}
</script>

<style scoped>
.face-capture {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.tip {
    position: fixed;
    top: 4.8rem;
    z-index: 5;
    font-size: 1.8rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 2.5rem;
}

.face-capture video,
.face-capture canvas {
    position: fixed;
    top: 11.75rem;
    object-fit: cover;
    z-index: 2;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transform: translate3d(0, 0, 0);
}

.face-capture .img-cover {
    position: fixed;
    top: 6.3rem;
    width: 37.5rem;
    height: 37.5rem;
    object-fit: cover;
    z-index: 3;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.face-capture .contentp {
    position: fixed;
    top: 43.8rem;
    font-size: 1.8rem;
    font-weight: 500;
    color: #333333;
}

.face-capture .rect {
    border: 0.2rem solid #0aeb08;
    position: fixed;
    z-index: 4;
}

.img-face {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.img-face .imgurl {
    position: fixed;
    top: 11.75rem;
    width: 26.6rem;
    height: 26.6rem;
    border-radius: 13.3rem;
}

.img-face .el-button {
    position: fixed;
    top: 42rem;
}
</style>